import React, { useState } from "react";
import { Link } from "react-router-dom";
import Star from "./Star";

const RateCourse = ({
  onClose,
  rating,
  setRating,
  handleRateCourse,
  course,
}) => {
  const [hovered, setHovered] = useState(0);

  const handleSelection = (index, isHovered = false) => {
    return isHovered ? setHovered(index) : setRating(index);
  };

  const getStyleName = (index, selction) => {
    return index <= selction ? "hover-star" : "normal-star";
  };

  return (
    <div className="rate-course">
      <div className="arrow-up"></div>
      <div className="close-button" onClick={() => onClose()}>
        <i className="icon check"></i>
      </div>
      <div className="star-text">How would you rate this course?</div>
      <div className="star-rating star-div">
        {[...Array(5)].map((_, index) => {
          index = index + 1;
          return (
            <button
              key={index}
              onMouseOver={() => handleSelection(index, true)}
              onMouseOut={() => setHovered(0)}
              onClick={() => handleSelection(index)}
            >
              <Star
                style={
                  rating && index <= rating
                    ? "full-star"
                    : getStyleName(index, hovered)
                }
              />
            </button>
          );
        })}
      </div>
      <div className="button-wrapper">
        <div className="btn btn-back">
          <a onClick={() => onClose()}>Later</a>
        </div>
        <div className="btn rate" onClick={() => handleRateCourse(course.ID)}>
          <Link>Rate</Link>
        </div>
      </div>
    </div>
  );
};

export default RateCourse;
